import React from "react";
import styles from "./viewTreatment.module.scss";
import { signedLockedAccess } from "../../../utils";
import { useSelector } from "react-redux";
import { assessmentRbacChecker } from "../../../utils/rbac";
import editIcon from "../../../static/images/edit-icon-blue.png";
import { EDIT } from "../../../constants";

export const TreatmentEditIcon = ({ editable, assessmentDetails, handleEdit }) => {
  const patientData = useSelector((state) => state.patient.detailViewData);
  const userDetails = useSelector((state) => state.user);
  const hideButtons = assessmentRbacChecker(userDetails?.role, patientData?.isOwnCustomer);

  return (
    !editable &&
    signedLockedAccess(assessmentDetails?.assessmentStage) &&
    hideButtons && (
      <div className={`${styles.edit_icon}`}>
        <span className={`float-sm-right ${styles.tab_edit} handleEdit`} onClick={handleEdit}>
          <img src={editIcon} alt="edit" />
          {EDIT}
        </span>
      </div>
    )
  );
};
